import { Modal, Button, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { msToHMS } from '../../helpers';
import Avatar from '../Avatar';

const ScheduleDetails = ({
  showScheduleDetails,
  setShowScheduleDetails,
  scheduleInfo,
  setSelectedEvent,
  deleteSchedule,
  handleEditScheduleDisplay,
}) => {
  const permissions = useSelector((state) => state.permissionsReducer);
  const handleClose = () => {
    setShowScheduleDetails(false);
    setSelectedEvent(null);
  };

  return (
    <Modal show={showScheduleDetails} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title className="m-0">Details</Modal.Title>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={handleClose}
        />
      </Modal.Header>
      {scheduleInfo && scheduleInfo.extendedProps && (
        <>
          <Modal.Body>
            <Row className="align-items-center">
              <Col className="col-auto">
                <div className="avatar avatar-md">
                  <Avatar
                    firstName={scheduleInfo.extendedProps.firstName}
                    lastName={scheduleInfo.extendedProps.lastName}
                    defaultBg={scheduleInfo.extendedProps.bgColor}
                    imgPath={scheduleInfo.extendedProps.avatar}
                  />
                </div>
              </Col>
              <Col className="ps-0">
                <h4 className="mb-0">
                  {scheduleInfo.extendedProps.userRealName}
                </h4>
              </Col>
              <Col className="col-auto">
                <span className="text-muted">
                  {moment.utc(scheduleInfo.start).format('ddd, MMM DD, YYYY')}
                </span>
              </Col>
            </Row>
            {!scheduleInfo.extendedProps.isLeave &&
              !scheduleInfo.extendedProps.isHoliday &&
              !scheduleInfo.extendedProps.isWeekend && (
                <div className="list-group mt-4">
                  <div className="list-group-item">
                    <Row className="align-items-center">
                      <Col>Shift name</Col>
                      <Col className="col-auto">
                        <span className="text-muted">
                          {scheduleInfo.title || 'Shift'}
                        </span>
                      </Col>
                    </Row>
                  </div>
                  <div className="list-group-item">
                    <Row className="align-items-center">
                      <Col>Scheduled time</Col>
                      <Col className="col-auto">
                        <span className="text-muted">
                          {moment
                            .utc(scheduleInfo.extendedProps.shiftStart)
                            .format('hh:mm A')}{' '}
                          -{' '}
                          {moment
                            .utc(scheduleInfo.extendedProps.shiftEnd)
                            .format('hh:mm A')}
                        </span>
                      </Col>
                    </Row>
                  </div>
                  {scheduleInfo.extendedProps.breaks &&
                    scheduleInfo.extendedProps.breaks.length > 0 && (
                      <div className="list-group-item">
                        <Row className="align-items-center">
                          <Col>Breaks</Col>
                          <Col className="col-auto">
                            {scheduleInfo.extendedProps.breaks.map((breaks) => (
                              <p className="m-0 text-end">
                                <span className="text-muted">
                                  {breaks.name}{' '}
                                  {breaks.shortCode
                                    ? `(${breaks.shortCode})`
                                    : ''}{' '}
                                  (
                                  {moment
                                    .utc(breaks.breakStart)
                                    .format('hh:mm A')}{' '}
                                  -{' '}
                                  {moment
                                    .utc(breaks.breakEnd)
                                    .format('hh:mm A')}
                                  )
                                </span>
                              </p>
                            ))}
                          </Col>
                        </Row>
                      </div>
                    )}
                  {scheduleInfo.extendedProps.isPast && (
                    <>
                      {scheduleInfo.extendedProps.firstCheckIn && (
                        <div className="list-group-item">
                          <Row className="align-items-center">
                            <Col>Check In</Col>
                            <Col className="col-auto">
                              <span className="text-muted">
                                {moment
                                  .utc(scheduleInfo.extendedProps.firstCheckIn)
                                  .format('hh:mm A')}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      )}
                      <div className="list-group-item">
                        <Row className="align-items-center">
                          <Col>Logged hours</Col>
                          <Col className="col-auto">
                            <span className="text-muted">
                              {scheduleInfo.extendedProps.workSessionMinutes > 0
                                ? msToHMS(
                                    Math.round(
                                      scheduleInfo.extendedProps
                                        .workSessionMinutes
                                    ) *
                                      60 *
                                      1000
                                  )
                                : 0}
                            </span>
                          </Col>
                        </Row>
                      </div>
                    </>
                  )}
                </div>
              )}
          </Modal.Body>
          {scheduleInfo.extendedProps.isLeave ||
          scheduleInfo.extendedProps.isHoliday ||
          scheduleInfo.extendedProps.isWeekend ? (
            <Modal.Footer className="justify-content-end">
              {permissions && permissions.includes('schedule_delete') && (
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    deleteSchedule(scheduleInfo.id);
                    handleClose();
                  }}
                >
                  Delete
                </Button>
              )}
            </Modal.Footer>
          ) : (
            <Modal.Footer className="justify-content-between">
              {permissions && permissions.includes('schedule_delete') && (
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    deleteSchedule(scheduleInfo.id);
                    handleClose();
                  }}
                >
                  Delete
                </Button>
              )}
              {permissions && permissions.includes('schedule_create') && (
                <Button
                  variant="primary"
                  onClick={() => {
                    handleEditScheduleDisplay(true);
                  }}
                >
                  Edit
                </Button>
              )}
            </Modal.Footer>
          )}
        </>
      )}
    </Modal>
  );
};

ScheduleDetails.propTypes = {
  showScheduleDetails: PropTypes.bool,
  setShowScheduleDetails: PropTypes.func,
  scheduleInfo: PropTypes.object,
  setSelectedEvent: PropTypes.func,
  deleteSchedule: PropTypes.func,
  handleEditScheduleDisplay: PropTypes.func,
};

export default ScheduleDetails;
